import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../../../services/auth.service';
import { useToast } from '../../../components/base/ToastContainer';

export default function Navbar() {
  const [showNotifications, setShowNotifications] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const { showToast } = useToast();
  const navigate = useNavigate();
  const user = authService.getCurrentUser();

  const handleLogout = () => {
    authService.logout();
    showToast('Sesión cerrada exitosamente', 'success');
    navigate('/login');
  };

  return (
    <nav className="bg-white border-b border-slate-200 fixed top-0 left-0 right-0 z-50">
      <div className="px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <img
              src="https://public.readdy.ai/ai/img_res/a5da628e-1b73-45a1-8b62-2654c682f99a.png"
              alt="Logo Sistema Medicamentos"
              className="h-10 w-auto object-contain"
            />
            <div className="hidden md:block">
              <h2 className="text-xl font-bold text-slate-800 tracking-tight">MedFlow</h2>
              <div className="flex items-center gap-2 mt-0.5">
                <p className="text-[10px] uppercase tracking-wider font-semibold text-slate-400">Gestión Integral</p>
                {user?.bodegas?.[0]?.nombre && (
                  <div className="flex items-center gap-1.5 px-2 py-0.5 bg-teal-50 text-teal-700 border border-teal-100 rounded-md shadow-sm">
                    <i className="ri-map-pin-2-line text-teal-500 text-xs"></i>
                    <span className="text-[10px] font-bold uppercase tracking-tight">Sede: {user.bodegas[0].nombre}</span>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="flex items-center space-x-4">
            <div className="relative">
              <input
                type="text"
                placeholder="Buscar medicamentos..."
                className="w-64 px-4 py-2 text-sm border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent"
              />
              <i className="ri-search-line absolute right-3 top-1/2 transform -translate-y-1/2 text-slate-400 text-lg"></i>
            </div>

            <div className="flex items-center gap-4">
              <button
                onClick={() => setShowNotifications(!showNotifications)}
                className="relative w-10 h-10 flex items-center justify-center text-slate-600 hover:text-teal-600 hover:bg-teal-50 rounded-lg transition-colors cursor-pointer"
              >
                <i className="ri-notification-3-line text-xl"></i>
                <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full"></span>
              </button>

              <div className="relative">
                <button
                  onClick={() => setShowUserMenu(!showUserMenu)}
                  className="flex items-center gap-3 px-3 py-2 hover:bg-slate-50 rounded-lg transition-colors cursor-pointer"
                >
                  <div className="w-8 h-8 bg-teal-500 rounded-full flex items-center justify-center">
                    <span className="text-white text-sm font-medium">
                      {user?.nombre?.charAt(0).toUpperCase() || 'A'}
                    </span>
                  </div>
                  <div className="text-left hidden md:block">
                    <p className="text-sm font-medium text-slate-800">{user?.nombre || 'Usuario'}</p>
                    <p className="text-xs text-slate-500">{user?.rol || 'Rol'}</p>
                  </div>
                  <i className="ri-arrow-down-s-line text-slate-400"></i>
                </button>

                {showUserMenu && (
                  <div className="absolute right-0 mt-2 w-56 bg-white rounded-lg shadow-lg border border-slate-200 py-2">
                    <button
                      onClick={() => { setShowUserMenu(false); navigate('/perfil'); }}
                      className="w-full flex items-center gap-3 px-4 py-2 text-sm text-slate-700 hover:bg-slate-50 transition-colors cursor-pointer"
                    >
                      <i className="ri-user-line text-slate-400"></i>
                      Mi Perfil
                    </button>
                    <div className="border-t border-slate-200 my-2"></div>
                    <button
                      onClick={handleLogout}
                      className="w-full flex items-center gap-3 px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors cursor-pointer"
                    >
                      <i className="ri-logout-box-line"></i>
                      Cerrar Sesión
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/*       {showNotifications && (
        <NotificationPanel onClose={() => setShowNotifications(false)} />
      )} */}
    </nav>
  );
}
